import type { ReactNode } from "react";
import {
    type GradeSelectorModalIdsType,
    MODAL_DISCLAIMER,
    MODAL_GRADE_SELECTOR_COMPARE,
} from "../utils/modalConstants";
import { showModal } from "../../../../common-deprecated/redux/actions/ModalActions";
import { useGradeSelectorDispatch, useGradeSelectorSelector } from "../redux/hooks";
import { MODAL_ERRORS } from "../../../../common-deprecated/utils/modalConstants";
import { MODAL_RETAILER_EXTERNAL_QR_CODE } from "../../../../shared-logic/features/retailer/utils/modalConstants";

type showModalHelperSettings = {
    content?: ReactNode;
};

type useGradeSelectorModalType = {
    showModalHelper: (type: GradeSelectorModalIdsType, settings?: showModalHelperSettings) => void;
};

/**
 * This hook is responsible for using the correct showModal dispatcher.
 *
 * @returns {showModalHelper} showModalHelper function which has to be called in order to show a modal, requires the modals' type.
 */
const useGradeSelectorModal = (): useGradeSelectorModalType => {
    const dispatch = useGradeSelectorDispatch();
    const { modals } = useGradeSelectorSelector((state) => state.modal);

    const showModalHelper = (type: GradeSelectorModalIdsType, settings: showModalHelperSettings = {}): void => {
        // Only show modal if the modal isn't already displayed.
        if (
            modals.length === 0 ||
            modals.find((modal) => modal.settings?.type === type) === undefined ||
            !modals.find((modal) => modal.settings?.type === type)?.show
        ) {
            switch (type) {
                // Error modal should not be triggered by anything other than the commonPostfetch
                case MODAL_ERRORS: {
                    break;
                }
                case MODAL_GRADE_SELECTOR_COMPARE: {
                    break;
                }
                // External QR code modal should net be triggered by anything other than useExternalLinkHandler().
                case MODAL_RETAILER_EXTERNAL_QR_CODE: {
                    break;
                }
                case MODAL_DISCLAIMER: {
                    dispatch(
                        showModal({
                            type,
                            content: settings?.content,
                        }),
                    );

                    break;
                }
                default: {
                    dispatch(
                        showModal({
                            type,
                        }),
                    );
                    break;
                }
            }
        }
    };

    return { showModalHelper };
};

export default useGradeSelectorModal;
